import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IAddToMultipleRostersParams,
  IGetMyUpshiftersCountParams,
  IMyUpshifter,
  IMyUpshiftersCount,
  TGetMyUpshiftersParams,
} from '@network/models/my-upshifter.model'

export class MyUpshiftersApi {
  constructor(private axios: AxiosService) {}

  getMyUpshifters = async (params?: TGetMyUpshiftersParams) => {
    const response = await this.axios.get<IPayload<IMyUpshifter[]>>(
      Endpoints.getMyUpshifters,
      params,
    )
    return response
  }

  getMyUpshiftersCount = async (params: IGetMyUpshiftersCountParams) => {
    const response = await this.axios.get<IPayload<IMyUpshiftersCount>>(
      Endpoints.getMyUpshiftersCount,
      params,
    )
    return response
  }

  addToMultipleRosters = async (
    id: number,
    params: IAddToMultipleRostersParams,
  ) => {
    const response = await this.axios.post(
      Endpoints.addToMultipleRosters(id),
      params,
    )
    return response
  }
}
